<section class="share-section" [ngClass]="customClasses">
  <div class="netfone-container share-wrapper">
    <h3 class="share-description">
      {{ description }}
    </h3>
    <ose-global-share-ribbon class="global-share-ribbon" [standalone]="false"></ose-global-share-ribbon>
  </div>
</section>
